export const PERSONA_STATUS_CONFIG = {
	validation_pending: { label: 'Validation Pending', badgeVariant: 'warning' as const },
	validated: { label: 'Validated', badgeVariant: 'success' as const }
};

export const PERSONA_GENERATING_LABEL = 'Generating';
